/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CampaignDto = {
  /**
   * 캠페인 ID
   */
  id: string;
  /**
   * 광고주 ID
   */
  advertiserId: string;
  /**
   * 광고주 회사명
   */
  advertiserName: string;
  /**
   * 캠페인명
   */
  name: string;
  /**
   * 총 예산
   */
  totalBudget: number;
  /**
   * 일 예산
   */
  dailyBudget?: number;
  /**
   * 광고 게재방법
   */
  deliveryMethod: CampaignDto.deliveryMethod;
  /**
   * 상태
   */
  status: CampaignDto.status;
  /**
   * 시작일
   */
  startAt?: string;
  /**
   * 종료일
   */
  endAt?: string;
  /**
   * 삭제 여부
   */
  isDeleted: boolean;
  /**
   * 삭제일
   */
  deletedAt?: string;
  /**
   * 생성일
   */
  createdAt: string;
  /**
   * 수정일
   */
  updatedAt: string;
};
export namespace CampaignDto {
  /**
   * 광고 게재방법
   */
  export enum deliveryMethod {
    ACCELERATED = "ACCELERATED",
    STANDARD = "STANDARD",
  }
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
